import React, { useState } from 'react';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { BulkChangeDealStageDialog } from '@/components/dialogs/BulkChangeDealStageDialog';

export const BulkChangeDealStageButton = ({ pipeline }) => {
	const { selected } = useSelector((state) => state.dealTable);

	const [open, setOpen] = useState(false);

	return (
		<>
			<Button
				variant='outlined'
				disabled={selected.length === 0}
				sx={{ borderRadius: '15px' }}
				onClick={() => setOpen(true)}
			>
				{'Change stage'}
				{selected.length > 0 && (
					<span style={{ marginLeft: '0.25em' }}>{`(${selected.length})`}</span>
				)}
			</Button>
			<BulkChangeDealStageDialog
				open={open}
				onClose={() => setOpen(false)}
				pipeline={pipeline}
			/>
		</>
	);
};
